import { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import Slider from "react-slick";
import CustomSlider from "../../../common/CustomSlider";
import ChallengeCard from "./ChallengeCard";
import ChallengeDetails from "./ChallengeDetailsV2";
import { Skeleton } from '@mui/material'
import { delay } from "../../../utils";
import { Forward, Back } from "../../../common/CustomIcons";
import useConfetti from "../../../hooks/useConfetti";
import WelcomeMessage from "./WelcomeMessage";

function ChallengeCards(props) {
    const { challenges, status = "", screenSize } = props;

    const [showSlider, setShowSlider] = useState(false);
    const [showSlider2, setShowSlider2] = useState(false);
    const [selected, setSelected] = useState(null);
    const [list, setList] = useState(null);
    const [page, setPage] = useState(0);
    const [delayHolder, setDelay] = useState(null);
    const sliderRef = useRef(null);
    const { element, trigger } = useConfetti();

    let settings = {
        dots: true,
        rows: 1,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        arrows: false,
        initialSlide: page,
    };

    if (screenSize == "xl") {
        settings = {
            ...settings,
            swipeToSlide: false,
            swipe: false,
            arrows: true,
            slidesToShow: list?.length > 1 ? 2 : 1,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
        }
    }

    useEffect(() => {
        if (props?.selected?.id) {
            setSelected(props?.selected);
        }
    }, [props?.selected?.id]);


    useEffect(() => {
        setList(challenges);
        sliderRef?.current?.slickGoTo(0);
    }, [challenges]);

    useEffect(() => {
        setShowSlider(selected?.id);
    }, [selected?.id]);

    const notice = {
        active: {
            h5: "No other active challenges.",
            p: ""
        },
        completed: {
            h5: "No History Found.",
            p: "Complete a challenge to add to your history."
        },
    }

    let sList = list;
    if (status == "active") {
        sList = list?.sort((a, b) => a.status - b.status)
    }

    if (status == "active" || status == "upcoming") {
        sList = list?.sort((a, b) => b.company - a.company)
    }


    return (
        <div id="challenge-cards" className={sList?.length < 2 ? "only-one" : ""}>
            <Slider {...settings} ref={sliderRef}>
                {
                    sList?.length
                        ? sList?.map((challenge) => {
                            return <ChallengeCard challenge={challenge} status={status} onSelect={() => {
                                setSelected(challenge);
                                clearTimeout(delayHolder);
                                setDelay(null);
                            }} />
                        })
                        : (sList === null)
                            ? <div id="challenge-card">
                                <Skeleton variant="rectangular" height={"100%"} width={"100%"} />
                            </div>
                            : <div id="challenge-card" className="challenge-card-es">
                                <div className="empty-statement">
                                    <h5>{notice[status]?.h5}</h5>
                                    <p>{notice[status]?.p}</p>
                                </div>
                            </div>
                }
            </Slider>

            <CustomSlider show={showSlider} setShowSlider={(bool) => {
                setShowSlider(bool);

                setDelay(delay(() => {
                    setSelected(null);
                }, 300))

            }}>
                <ChallengeDetails screenSize={screenSize} status={status} challenge={selected} showWelcomeMsg={setShowSlider2} fireConfetti={trigger} />
            </CustomSlider>

            <CustomSlider show={showSlider2} setShowSlider={(bool) => {
                setShowSlider2(bool);
            }}>
                {selected ? <WelcomeMessage challenge={selected} confetti={element} /> : ""}
            </CustomSlider>
        </div>
    );
}




function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style }}
            onClick={onClick}
        >
            <Forward />
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
            className={className}
            style={{ ...style }}
            onClick={onClick}
        >
            <Back />
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Challenge: state.Challenge,
});

export default connect(mapStateToProps, {
})(ChallengeCards);